import Swiper from 'swiper';
import {Autoplay, Grid, Navigation} from 'swiper/modules';
import anime from "animejs";
import {openFullscreenGallery} from "./fullscreengallery";

function resizeActiveSlide(swiperImageGallery,effInterval=400,first = false) {
    let currentSlideIndex = swiperImageGallery.activeIndex;
    let i = 0;

    for(let slide of swiperImageGallery.slides){
        let slideImgContainer = slide.querySelector('.imageGallery__img');
        let slideTextContainer = slide.querySelector('.imageGallery__text');
        if(slideImgContainer){
            slideImgContainer.style.width = null;
        }
        if(slideTextContainer){
            anime({
                targets: slideTextContainer,
                opacity: 0,
                easing: "linear",
                duration: effInterval
            });
        }
        slide.classList.remove('swiper-slide-scale');
    }
    if(first){
        effInterval = 0;
    }
    setTimeout(function () {
        for(let slide of swiperImageGallery.slides){
            let slideImgContainer = slide.querySelector('.imageGallery__img');
            let slideTextContainer = slide.querySelector('.imageGallery__text');
            if(i === currentSlideIndex && slide.classList.contains('swiper-slide-active')){
                slide.classList.add('swiper-slide-scale');
                if(slideImgContainer){
                    let slideImg = slideImgContainer.querySelector('img');
                    if(slideImg){
                        if(slideImg.complete){
                            slideImgContainer.style.width = slideImg.width +"px";
                        }
                        slideImg.onload = function () {
                            if(slideImg.complete){
                                slideImgContainer.style.width = slideImg.width +"px";
                            }
                        };
                    }
                }
                if(slideTextContainer){
                    anime({
                        targets: slideTextContainer,
                        opacity: 1,
                        easing: "linear",
                        duration: effInterval
                    });
                }
            }
            i++;
        }
    },effInterval);
}

export function initImageGallery(query = document.querySelectorAll('div:not(.isScrollingSlider)>.imageGallery')) {
    let loops = {
        xs: false,
        sm: false,
        md: false,
        lg: false
    };

    let defaultOptions = {
        autoplay_interval: 3000,
        eff_interval: 1000,
        slidesPerBreakpoint: {
            xs: 1.5,
            sm: 3,
            md: 4,
            lg: 4
        }
    };

    for(const el of query){
        let options = {};

        if (el.getAttribute('data-options') !== "") {
            options = JSON.parse(el.getAttribute('data-options'));
        }

        options = {...defaultOptions,...options};
        let countSlides = el.querySelectorAll('.swiper-slide').length;

        if(countSlides >= options.slidesPerBreakpoint.lg){
            loops.lg = true;
        }

        if(countSlides >= options.slidesPerBreakpoint.md){
            loops.md = true;
        }

        if(countSlides >= options.slidesPerBreakpoint.sm){
            loops.sm = true;
        }

        if(countSlides >= options.slidesPerBreakpoint.xs){
            loops.xs = true;
        }

        Swiper.use([Autoplay,Navigation]);
        const swiperImageGallery = new Swiper(el, {
            speed: options.eff_interval,
            slideToClickedSlide: false,
            preventClicks: false,
            spaceBetween: 40,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            autoplay: {
                delay: options.autoplay_interval,
            },
            breakpoints: {
                0: {
                    loop: loops.xs,
                    slidesPerView: options.slidesPerBreakpoint.xs,
                    spaceBetween: 20,
                    centeredSlides: true
                },
                768: {
                    loop: loops.sm,
                    slidesPerView: options.slidesPerBreakpoint.sm,
                    centeredSlides: true
                },
                1250: {
                    loop: loops.md,
                    slidesPerView: options.slidesPerBreakpoint.md,
                    centeredSlides: false
                },
                1540: {
                    loop: loops.lg,
                    slidesPerView: options.slidesPerBreakpoint.lg
                }
            },
            on: {
                init: function() {
                    resizeActiveSlide(this,options.eff_interval,true);
                },
                slideChange: function () {
                    resizeActiveSlide(this,options.eff_interval);
                }
            },
        });
        if(options.autoplay_interval === 0){
            swiperImageGallery.autoplay.stop();
        }
        el.addEventListener('mouseover',function(){
            swiperImageGallery.autoplay.stop();
        });

        el.addEventListener('mouseleave',function(){
            swiperImageGallery.autoplay.start();
        });
    }
}

export function initScrollingImageGallery() {
    for (let scrollingImageGallery of document.querySelectorAll('.isScrollingSlider>.imageGallery')) {
        Swiper.use([Navigation]);
        const swiper = new Swiper(scrollingImageGallery, {
            direction: 'horizontal',
            slidesPerView: 1.5,
            spaceBetween: 20,
            freeMode: true,
            freeModeMomentum: true,
            freeModeMomentumRatio: 0.6,      // sanfteres Ausgleiten
            freeModeMomentumVelocityRatio: 0.6,
            freeModeSticky: false,
            speed: 600,                      // weichere Übergangszeit
            touchRatio: 1,
            resistanceRatio: 0.65,
            breakpoints: {
                768: {
                    slidesPerView: 1.9,
                },
                1024: {
                    spaceBetween: 40,
                    slidesPerView: 3.2,
                },
            }
        });

        const swiperContainer = document.querySelector('.isScrollingSlider');
        const swiperWrapper = document.querySelector('.swiper-wrapper');
        let inViewport = false;
        let centered = false;

        // Observer: Sichtbarkeit des Sliders erkennen
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                inViewport = entry.isIntersecting;

                if (inViewport && !centered) {
                    const slideWidth = swiperWrapper.querySelector('.swiper-slide').offsetWidth;
                    const targetIndex = 4; // Damit Slide 3 (Index 2) mittig ist bei 4 sichtbaren Slides
                    const targetOffset = targetIndex * slideWidth;
                    swiper.setTranslate(-targetOffset);
                    centered = true;
                }
            });
        }, {
            threshold: 0.1
        });

        observer.observe(swiperContainer);

        // Scroll steuert horizontale Position, nur wenn sichtbar
        // Nutze requestAnimationFrame für flüssigere Updates
        let rafId = null;
        let lastScrollY = window.scrollY;

        const onScroll = () => {
            lastScrollY = window.scrollY;
            if (rafId === null) {
                rafId = requestAnimationFrame(() => {
                    rafId = null;
                    if (inViewport) {
                        const offsetTop = swiperContainer.offsetTop;
                        const scrollOffset = lastScrollY - offsetTop;

                        // Verwende setTransition/tween für weichere Bewegung
                        swiper.setTransition(300); // weiche Interpolation
                        swiper.setTranslate(-scrollOffset);
                    }
                });
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });

        // Body-Höhe basierend auf Wrapper-Breite
        document.body.style.height = `${window.innerHeight + swiperWrapper.scrollWidth - window.innerWidth}px`;
    }
}